import {
  queryOrganizationPerformance,
  type OrganizationPerformance,
} from "../../../../api/kehrblatt/organization-performance"

export const createOrganizationPerformanceController = (query = queryOrganizationPerformance) => {
  let byOrganization = $state<Record<string, OrganizationPerformance>>({})
  let loading = $state(false)
  let error = $state<string | null>(null)
  let asOf = $state<string | null>(null)
  let revision = $state(0)
  let controller: AbortController | null = null
  let selection: string[] = []

  const invalidate = () => {
    controller?.abort()
    controller = null
    selection = []
    byOrganization = {}
    loading = false
    error = null
    asOf = null
    revision += 1
  }

  const load = async (organizationIds: string[]) => {
    invalidate()
    selection = [...new Set(organizationIds)]

    if (!selection.length) return

    const current = new AbortController()
    controller = current
    loading = true
    const items: Record<string, OrganizationPerformance> = {}
    let sharedAsOf: string | undefined
    try {
      for (let offset = 0; offset < selection.length; offset += 500) {
        const response = await query(selection.slice(offset, offset + 500), {
          signal: current.signal,
          asOf: sharedAsOf,
        })

        if (current.signal.aborted) return

        sharedAsOf = response.as_of
        for (const item of response.items) items[item.organization_id] = item
      }

      byOrganization = items
      asOf = sharedAsOf ?? null
    } catch {
      if (current.signal.aborted) return

      error = "Verbrauch und Gewinn konnten nicht geladen werden."
    } finally {
      if (controller === current) {
        controller = null
        loading = false
        revision += 1
      }
    }
  }

  return {
    get byOrganization() {
      return byOrganization
    },
    get loading() {
      return loading
    },
    get error() {
      return error
    },
    get asOf() {
      return asOf
    },
    get revision() {
      return revision
    },
    load,
    invalidate,
    retry: () => load([...selection]),
  }
}
